import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981'];

const LpoVsWalkinChart = ({ data }) => {
    if (!data || !data.by_location || data.by_location.length === 0) return null;

    const labels = data.by_location.map(d => d.location_name);
    const walkinRevenue = data.by_location.map(d => d.walkin_revenue);
    const lpoRevenue = data.by_location.map(d => d.lpo_revenue);
    const totals = data.totals || {};

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Walk-in Revenue (BHD)',
                data: walkinRevenue,
                backgroundColor: COLORS[0],
                borderRadius: 4,
            },
            {
                label: 'LPO Revenue (BHD)',
                data: lpoRevenue,
                backgroundColor: COLORS[1],
                borderRadius: 4,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
        },
        scales: {
            x: { stacked: true },
            y: {
                stacked: true,
                title: { display: true, text: 'Revenue (BHD)' },
            },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">LPO vs Walk-in Revenue</h6>
                <Bar data={chartData} options={options} />
                <div className="row mt-3 text-center g-2">
                    <div className="col-4">
                        <small className="text-muted d-block">Walk-in Rev</small>
                        <strong>{totals.walkin_revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">LPO Rev</small>
                        <strong>{totals.lpo_revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                    </div>
                    <div className="col-4">
                        <small className="text-muted d-block">Walk-in Orders</small>
                        <strong>{totals.walkin_count}</strong>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LpoVsWalkinChart;
